import { createAsyncThunk } from '@reduxjs/toolkit';

import { updateUserEmployerBusinessIdResources } from 'store/userProfile/services/update-user-employer-business-id-resources.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

/**
 * Thunk to update user employer business ID resources.
 * @param {Object} params - Parameters for the update.
 * @param {string} params.businessId - employer business ID.
 * @param {string} params.userId - ID of the user whose resources are to be updated.
 * @param {Object} params.updates - The updates to be applied to the resources.,
 * @param {string} params.selectedResourceId - ID of the selected resource.
 * @returns {Object} - The updated resource.
 */
export const setUpdateUserEmployerBusinessIdResources = createAsyncThunk(
  'users/setUpdateUserEmployerBusinessIdResources',
  async (params, { getState }) => {
    const state = getState();
    const selectedProjectId = selectSelectedProjectId(state);

    const _params = {
      ...params,
      projectId: selectedProjectId
    }

    const updatedResource = await updateUserEmployerBusinessIdResources(_params);

    return updatedResource;
  }
);